import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState(false);

const API = "https://api.freshcart4u.com/api/auth";
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (loading) return;

    if (!token) {
      return setMessage("Invalid or broken reset link");
    }

    if (!password || !confirmPassword) {
      return setMessage("All fields are required");
    }

    if (password !== confirmPassword) {
      return setMessage("Passwords do not match");
    }

    if (password.length < 6) {
      return setMessage("Password must be at least 6 characters");
    }

    try {
      setLoading(true);
      setMessage("");

      console.log("🔑 TOKEN:", token);

      const res = await axios({
        method: "POST", // 🔥 explicitly define
        url: `${API}/reset-password/${token}`,
        data: { password },
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });

      setSuccess(true);
      setMessage(res.data.message || "Password reset successful");

      setTimeout(() => {
        navigate("/login");
      }, 2000);

    } catch (err) {
      console.log("❌ FULL ERROR:", err);

      // 🔥 Better error handling
      if (err.response?.status === 405) {
        setMessage("Server not allowing POST request (405 error)");
      } else if (err.response?.status === 400) {
        setMessage(err.response.data.message || "Invalid or expired token");
      } else {
        setMessage(
          err.response?.data?.message ||
          err.message ||
          "Something went wrong"
        );
      }

    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.heading}>Reset Password</h2>

        <form onSubmit={handleSubmit} style={styles.form}>
          <input
            type="password"
            placeholder="New Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={styles.input}
          />

          <input
            type="password"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            style={styles.input}
          />

          <button
            type="submit"
            disabled={loading}
            style={{
              ...styles.button,
              opacity: loading ? 0.7 : 1,
              cursor: loading ? "not-allowed" : "pointer",
            }}
          >
            {loading ? "Please wait..." : "Reset Password"}
          </button>
        </form>

        {message && (
          <p
            style={{
              marginTop: "15px",
              color: success ? "green" : "red",
              textAlign: "center",
              fontWeight: "500",
            }}
          >
            {message}
          </p>
        )}
      </div>
    </div>
  );
};

/* ================== STYLES ================== */

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#f5f5f5",
  },
  card: {
    background: "#fff",
    padding: "30px",
    borderRadius: "10px",
    boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
    width: "320px",
  },
  heading: {
    textAlign: "center",
    marginBottom: "20px",
    fontSize: "22px",
    fontWeight: "600",
  },
  form: {
    display: "flex",
    flexDirection: "column",
  },
  input: {
    margin: "10px 0",
    padding: "12px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "14px",
    outline: "none",
  },
  button: {
    padding: "12px",
    background: "green",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    fontSize: "16px",
    fontWeight: "500",
  },
};

export default ResetPassword;